import React, { useEffect, useState } from 'react';
import { useTemperaturesWinds } from '../../services/temperaturesWinds/temperaturesWinds';
import { Marker, Polyline, useMap, useMapEvents } from 'react-leaflet';
import './Winds.css';

export const Winds = () => {
    const map = useMap();
    const temperaturesWinds = useTemperaturesWinds();
    const [ reload, setReload ] = useState<any>(false);
    const [ winds, setWinds ] = useState<any>([]);

    useMapEvents({
        zoom: (event) => {
            setReload(!reload);
        },
        move: (event) => {
            setReload(!reload);
        }
    })

    // const init = () => {
    //     if (temperaturesWinds) {
    //         const data=  temperaturesWinds.getWinds();
    //         setWinds(data); 
    //     }
    // }

    useEffect(() => {
        if (temperaturesWinds) {
            temperaturesWinds.map = map;
            const data = temperaturesWinds.getWinds();
            
            // Adjust the vertical offset for each wind marker
            const adjustedData = data.map((element: any) => {
                if (!element) return null;
                
                const point = map.latLngToLayerPoint(element.position);
                
                const offsetPoint = point.subtract([0, 20]); // Offset by 20 pixels up
                
                const offsetPosition = map.layerPointToLatLng(offsetPoint);
                
                const adjustedArrow = element.arrow.map((pos: any) => {
                    const arrowPoint = map.latLngToLayerPoint([pos[0], pos[1]]);
                    const offsetArrowPoint = arrowPoint.subtract([0, 20]);
                    const newPos = map.layerPointToLatLng(offsetArrowPoint);
                    return [newPos.lat, newPos.lng];
                });

                return {
                    ...element,
                    position: [offsetPosition.lat, offsetPosition.lng],
                    arrow: adjustedArrow
                };
            });

            setWinds(adjustedData);
        }
    }, [temperaturesWinds, reload, map]);

    return (
        <>
            {
                winds && winds.map((element: any, index:number) => {
                    const limeOptions = {
                        color: '#5470B9',
                        fillColor: '#5470B9',
                        strokeOpacity: 1,
                        strokeWeight: 3,
                        fillOpacity:1,
                    }
                    const whiteLineOptions = {
                        color: '#FFFFFF',
                        strokeOpacity: 1,
                        weight: 6,
                        fillOpacity: 1,
                    };
                    return (
                        element &&<div key={index} className={'map-element'}>
                            <Polyline 
                                pathOptions={whiteLineOptions}
                                positions={element.arrow}
                                pane='alertMarkersPane'
                            />
                            <Polyline  pathOptions={limeOptions} positions={element.arrow} pane='alertMarkersPane'/>
                            <Marker  position={element.position} icon={element.icon} pane='overlayMarkersPane'/>
                        </div>
                        
                    )
                })
            }
        </>
    );
}
